<template>
    <div data-app>
        <section class="bg--white m-0 position-relative no-padding">
            <div class="container-fluid">
                <div class="row">
                    <div class="main col-12 col-md-10 offset-lg-1 mt-4">
                        <div class="intro col-12 col-md-8">
                            <h2 class="mb-2">Mijn Overzicht</h2>
                            <slot name="introductionText"></slot>
                        </div>

                        <v-tabs class="font-family--header">
                            <v-tab href="#one">Actieve boekingen</v-tab>
                            <v-tab-item id="one">
                                <template>
                                    <v-data-table
                                        :headers="bookingHeaders"
                                        :items="currentBookingItems"
                                        :expanded.sync="expanded"
                                        show-expand
                                        single-expand
                                        item-key="Invoice"
                                        :search="searchTerm"
                                        :page.sync="page"
                                        :items-per-page="itemsPerPage"
                                        class="elevation-1 font-family--body"
                                        @click:row="
                                            (item, slot) =>
                                                slot.expand(!slot.isExpanded)
                                        "
                                    >
                                        <template v-slot:top>
                                            <v-row align="center">
                                                <p
                                                    class="pt-2 mt-2 pb-0 ml-2 mb-0"
                                                >
                                                    Filter resultaten:
                                                </p>
                                            </v-row>
                                            <v-row align="center">
                                                <v-col
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-select
                                                        v-model="
                                                            groupsFilterValue
                                                        "
                                                        :items="
                                                            currentGroupsList
                                                        "
                                                        label="Groep"
                                                        single
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col
                                                    v-if="
                                                        profile.ContentTypeAlias !=
                                                            'parent'
                                                    "
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-select
                                                        v-model="
                                                            providerFilterValue
                                                        "
                                                        :items="
                                                            currentProviderList
                                                        "
                                                        label="Aanbieder"
                                                        single
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col
                                                    v-if="
                                                        profile.ContentTypeAlias ==
                                                            'parent'
                                                    "
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-select
                                                        v-model="
                                                            childFilterValue
                                                        "
                                                        :items="
                                                            currentChildList
                                                        "
                                                        label="Kind"
                                                        single
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-card-title class="pt-0">
                                                        <v-text-field
                                                            v-model="searchTerm"
                                                            append-icon="fa-magnify"
                                                            label="Zoeken"
                                                            single-line
                                                            hide-details
                                                        ></v-text-field>
                                                    </v-card-title>
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <template
                                            v-slot:expanded-item="{ item }"
                                        >
                                            <td
                                                colspan="2"
                                                class="cell__mobile"
                                            ></td>
                                            <td class="cell__mobile--large">
                                                {{ item.ProviderStreet }}
                                                {{ item.ProviderHouseNumber }}
                                                {{
                                                    item.ProviderHouseNumberAddition
                                                }}
                                                <br />
                                                {{ item.ProviderPostalCode }}
                                                {{ item.ProviderCity }} <br />
                                                <a
                                                    :href="
                                                        `https://${item.ProviderWebsite}`
                                                    "
                                                    target="_blank"
                                                >
                                                    {{ item.ProviderWebsite }}
                                                </a>
                                                <div v-if="item.Comments">
                                                    Opmerkingen
                                                    <br />
                                                    {{ item.Comments }}
                                                </div>
                                            </td>
                                            <td
                                                colspan="3"
                                                class="table-bottom text-right cell__mobile"
                                            ></td>
                                            <td
                                                colspan="3"
                                                class="text-left cell__mobile--large"
                                            >
                                                <span v-if="item.StudentNumber">
                                                    Aantal leerlingen:
                                                    {{ item.StudentNumber }}
                                                    <br />
                                                </span>
                                                <span v-if="item.Price">
                                                    Prijs: €
                                                    {{ item.Price }}
                                                    <br />
                                                </span>
                                                <span v-if="item.NewPrice">
                                                    De nieuwe prijs na
                                                    kortingen: €
                                                    {{ item.NewPrice }}
                                                    <br />
                                                </span>
                                                <span v-if="item.DiscountType">
                                                    Er is gebruik gemaakt van de
                                                    volgende kortingen:
                                                    {{ item.DiscountType }}
                                                    <br />
                                                </span>
                                                <span v-if="item.Invoice">
                                                    Factuurnummer:
                                                    {{ item.Invoice }}
                                                    <br />
                                                </span>
                                                {{ item.Notice }}
                                                <div
                                                    v-if="
                                                        item.ProviderPhone !=
                                                            null
                                                    "
                                                >
                                                    <a
                                                        class="button w-100 btn--dance button--small mt-2"
                                                        :href="
                                                            'tel:' +
                                                                item.ProviderPhone
                                                        "
                                                    >
                                                        <span>
                                                            <span
                                                                class="d-none d-md-inline-block"
                                                                >Bel</span
                                                            >
                                                            <i
                                                                class="ml-1 color--white fas fa-phone"
                                                            ></i>
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    v-if="
                                                        item.ProviderEmail !=
                                                            null
                                                    "
                                                >
                                                    <a
                                                        class="button w-100 btn button--small mt-2"
                                                        :href="
                                                            'mailto:' +
                                                                item.ProviderEmail
                                                        "
                                                        target="_blank"
                                                    >
                                                        <span>
                                                            <span
                                                                class="d-none d-md-inline-block"
                                                                >E-mail</span
                                                            >
                                                            <i
                                                                class="ml-1 color--white fas fa-envelope"
                                                            ></i>
                                                        </span>
                                                    </a>
                                                </div>
                                                <hr />
                                                <v-col cols="auto">
                                                    <v-dialog
                                                        v-model="dialog"
                                                        transition="dialog-bottom-transition"
                                                        max-width="600"
                                                        @click:outside="
                                                            unexpand
                                                        "
                                                    >
                                                        <template
                                                            v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }"
                                                        >
                                                            <a
                                                                class="btn w-100 btn--medium btn--culture"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <span>
                                                                    Wijzig of
                                                                    Cancel
                                                                </span>
                                                            </a>
                                                        </template>
                                                        <hr />
                                                        <v-card>
                                                            <v-container>
                                                                <div
                                                                    v-if="
                                                                        optionCancel
                                                                    "
                                                                >
                                                                    <v-card-title
                                                                        class="headline"
                                                                    >
                                                                        Wijzig
                                                                        je
                                                                        boeking
                                                                    </v-card-title>
                                                                    <v-card-text>
                                                                        Vul de
                                                                        velden
                                                                        in die
                                                                        je wilt
                                                                        wijzigen.
                                                                    </v-card-text>
                                                                </div>
                                                                <div
                                                                    v-if="
                                                                        !optionCancel
                                                                    "
                                                                >
                                                                    <v-card-title
                                                                        class="headline"
                                                                    >
                                                                        Cancel
                                                                        je
                                                                        boeking
                                                                    </v-card-title>
                                                                    <v-card-text>
                                                                        Geef aan
                                                                        waarom
                                                                        je de
                                                                        boeking
                                                                        wil
                                                                        cancellen.
                                                                    </v-card-text>
                                                                </div>
                                                                <v-row
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                    <v-col
                                                                        cols="12"
                                                                    >
                                                                        <v-btn-toggle
                                                                            v-model="
                                                                                cancelToggleButton
                                                                            "
                                                                            mandatory
                                                                            class="toggle-btn"
                                                                        >
                                                                            <v-btn
                                                                                class="toggle-btn__option"
                                                                                @click="
                                                                                    optionCancel = true
                                                                                "
                                                                            >
                                                                                <span>
                                                                                    <i
                                                                                        class="fas fa-edit"
                                                                                    ></i>
                                                                                    Wijzig</span
                                                                                >
                                                                            </v-btn>
                                                                            <v-btn
                                                                                class="toggle-btn__option"
                                                                                @click="
                                                                                    optionCancel = false
                                                                                "
                                                                            >
                                                                                <span>
                                                                                    <i
                                                                                        class="fas fa-trash-alt"
                                                                                    ></i>
                                                                                    Cancel</span
                                                                                >
                                                                            </v-btn>
                                                                        </v-btn-toggle>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row
                                                                    v-if="
                                                                        optionCancel
                                                                    "
                                                                >
                                                                    <div>
                                                                        <v-col
                                                                            cols="12"
                                                                        >
                                                                            <label
                                                                                for="changeClass"
                                                                                class="col-12 label--default"
                                                                                >Groep</label
                                                                            >
                                                                            <input
                                                                                id="changeClass"
                                                                                v-model="
                                                                                    item.Class
                                                                                "
                                                                                class="input--default input--rounded"
                                                                            />
                                                                        </v-col>
                                                                        <v-col
                                                                            v-if="
                                                                                !item.ChildSchool
                                                                            "
                                                                            cols="auto"
                                                                        >
                                                                            <label
                                                                                for="changeStudentNr"
                                                                                class="col-12 label--default"
                                                                                >Aantal
                                                                                leerlingen
                                                                            </label>
                                                                            <input
                                                                                id="changeStudentNr"
                                                                                v-model="
                                                                                    item.StudentNumber
                                                                                "
                                                                                class="input--default input--rounded"
                                                                            />
                                                                        </v-col>
                                                                        <v-col
                                                                            v-else
                                                                            cols="auto"
                                                                        >
                                                                            <label
                                                                                for="changeFirstName"
                                                                                class="col-12 label--default"
                                                                                >Voornaam
                                                                            </label>
                                                                            <input
                                                                                id="changeFirstName"
                                                                                v-model="
                                                                                    item.ContactPersonFirstname
                                                                                "
                                                                                class="input--default input--rounded"
                                                                            />
                                                                        </v-col>
                                                                        <v-col
                                                                            v-if="
                                                                                !item.ChildSchool
                                                                            "
                                                                            cols="auto"
                                                                        >
                                                                            <label
                                                                                for="changeRegistrationName"
                                                                                class="col-12 label--default"
                                                                                >Naam
                                                                                leerkracht</label
                                                                            >
                                                                            <input
                                                                                id="changeRegistrationName"
                                                                                v-model="
                                                                                    item.ContactName
                                                                                "
                                                                                class="input--default input--rounded"
                                                                            />
                                                                        </v-col>
                                                                        <v-col
                                                                            v-else
                                                                            cols="auto"
                                                                        >
                                                                            <label
                                                                                for="changeLastName"
                                                                                class="col-12 label--default"
                                                                                >Achternaam
                                                                            </label>
                                                                            <input
                                                                                id="changeLastName"
                                                                                v-model="
                                                                                    item.ContactPersonFirstname
                                                                                "
                                                                                class="input--default input--rounded"
                                                                            />
                                                                        </v-col>
                                                                        <v-col
                                                                            v-if="
                                                                                !item.ChildSchool
                                                                            "
                                                                            cols="auto"
                                                                        >
                                                                            <label
                                                                                for="changeEmail"
                                                                                class="col-12 label--default"
                                                                                >E-mailadres
                                                                                leerkracht</label
                                                                            >
                                                                            <input
                                                                                id="changeEmail"
                                                                                v-model="
                                                                                    item.ContactEmail
                                                                                "
                                                                                class="input--default input--rounded"
                                                                            />
                                                                        </v-col>
                                                                        <v-col
                                                                            v-else
                                                                            cols="auto"
                                                                        >
                                                                            <label
                                                                                for="changeLastName"
                                                                                class="col-12 label--default"
                                                                                >School
                                                                            </label>
                                                                            <input
                                                                                id="changeSchool"
                                                                                v-model="
                                                                                    item.ChildSchool
                                                                                "
                                                                                class="input--default input--rounded"
                                                                            />
                                                                        </v-col>
                                                                        <v-col
                                                                            v-if="
                                                                                !item.ChildSchool
                                                                            "
                                                                            cols="auto"
                                                                        >
                                                                            <label
                                                                                for="changePhone"
                                                                                class="col-12 label--default"
                                                                                >Telefoonnummer
                                                                                leerkracht</label
                                                                            >
                                                                            <input
                                                                                id="changePhone"
                                                                                v-model="
                                                                                    item.ContactPhone
                                                                                "
                                                                                class="input--default input--rounded"
                                                                            />
                                                                        </v-col>
                                                                        <v-col
                                                                            cols="12"
                                                                        >
                                                                            <textarea-input
                                                                                v-model="
                                                                                    item.Comments
                                                                                "
                                                                                class="mb-2 px-3"
                                                                                name="Opmerkingen"
                                                                            />
                                                                        </v-col>
                                                                    </div>
                                                                    <v-card-actions
                                                                        class="justify-content-center"
                                                                    >
                                                                        <button
                                                                            class="btn btn--medium btn--blue-7 mt-2 mr-1"
                                                                            @click="
                                                                                updateRegistration(
                                                                                    item
                                                                                ),
                                                                                    (dialog = false)
                                                                            "
                                                                        >
                                                                            <span>
                                                                                Ja,
                                                                                wijzig
                                                                                boeking
                                                                                <i
                                                                                    class="ml-1 color--white fas fa-check"
                                                                                ></i>
                                                                            </span>
                                                                        </button>
                                                                        <button
                                                                            class="btn btn--medium btn--culture mt-2 ml-1"
                                                                            @click="
                                                                                dialog = false
                                                                            "
                                                                        >
                                                                            <span>
                                                                                Annuleren
                                                                                <i
                                                                                    class="ml-1 color--white fas fa-times"
                                                                                ></i>
                                                                            </span>
                                                                        </button>
                                                                    </v-card-actions>
                                                                </v-row>
                                                                <v-row
                                                                    v-if="
                                                                        !optionCancel
                                                                    "
                                                                >
                                                                    <v-col
                                                                        cols="auto"
                                                                    >
                                                                        <textarea-input
                                                                            v-model="
                                                                                cancellationMessage
                                                                            "
                                                                            class="mb-2 px-3"
                                                                            name="Opmerkingen"
                                                                        />
                                                                    </v-col>
                                                                    <hr />
                                                                    <v-card-actions
                                                                        class="justify-content-center"
                                                                    >
                                                                        <button
                                                                            class="btn btn--medium btn--blue-7 mt-2 mr-1"
                                                                            @click="
                                                                                cancelRegistration(
                                                                                    item
                                                                                ),
                                                                                    (dialog = false)
                                                                            "
                                                                        >
                                                                            <span>
                                                                                Ja,
                                                                                cancel
                                                                                boeking
                                                                                <i
                                                                                    class="ml-1 color--white fas fa-check"
                                                                                ></i>
                                                                            </span>
                                                                        </button>
                                                                        <button
                                                                            class="btn btn--medium btn--culture mt-2 ml-1"
                                                                            @click="
                                                                                dialog = false
                                                                            "
                                                                        >
                                                                            <span>
                                                                                Annuleren
                                                                                <i
                                                                                    class="ml-1 color--white fas fa-times"
                                                                                ></i>
                                                                            </span>
                                                                        </button>
                                                                    </v-card-actions>
                                                                </v-row>
                                                            </v-container>
                                                        </v-card>
                                                    </v-dialog>
                                                </v-col>
                                            </td>
                                        </template>
                                    </v-data-table>
                                    <p
                                        v-if="!currentBookingItems"
                                        class="pt-2 pl-2"
                                    >
                                        Er zijn geen boekingen
                                    </p>
                                    <div class="text-center pt-2">
                                        <v-pagination
                                            v-model="page"
                                            :length="
                                                getPageCount(
                                                    currentBookingItems
                                                )
                                            "
                                        ></v-pagination>
                                    </div>
                                </template>
                            </v-tab-item>

                            <v-tab href="#two">Boekingsgeschiedenis</v-tab>
                            <v-tab-item id="two">
                                <template>
                                    <v-data-table
                                        :headers="bookingHeaders"
                                        :items="pastBookingItems"
                                        show-expand
                                        single-expand
                                        item-key="Invoice"
                                        :search="searchTerm"
                                        :page.sync="page"
                                        :items-per-page="itemsPerPage"
                                        class="elevation-1 font-family--body"
                                        @page-count="pageCount = $event"
                                        @click:row="
                                            (item, slot) =>
                                                slot.expand(!slot.isExpanded)
                                        "
                                    >
                                        <template v-slot:top>
                                            <v-row align="center">
                                                <p
                                                    class="pt-2 mt-2 pb-0 ml-2 mb-0"
                                                >
                                                    Filter resultaten:
                                                </p>
                                            </v-row>
                                            <v-row align="center">
                                                <v-col
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-select
                                                        v-model="
                                                            providerFilterValue
                                                        "
                                                        :items="
                                                            pastProviderList
                                                        "
                                                        label="Aanbieder"
                                                        single
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col
                                                    v-if="
                                                        profile.ContentTypeAlias !=
                                                            'parent'
                                                    "
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-select
                                                        v-model="
                                                            groupsFilterValue
                                                        "
                                                        :items="pastGroupsList"
                                                        label="Groep"
                                                        single
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col
                                                    v-if="
                                                        profile.ContentTypeAlias ==
                                                            'parent'
                                                    "
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-select
                                                        v-model="
                                                            childFilterValue
                                                        "
                                                        :items="pastChildList"
                                                        label="Kind"
                                                        single
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-card-title class="pt-0">
                                                        <v-text-field
                                                            v-model="searchTerm"
                                                            append-icon="fa-magnify"
                                                            label="Zoeken"
                                                            single-line
                                                            hide-details
                                                        ></v-text-field>
                                                    </v-card-title>
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <template
                                            v-slot:expanded-item="{ item }"
                                        >
                                            <td
                                                colspan="2"
                                                class="cell__mobile"
                                            ></td>
                                            <td>
                                                {{ item.ProviderStreet }}
                                                {{ item.ProviderHouseNumber }}
                                                {{
                                                    item.ProviderHouseNumberAddition
                                                }}
                                                <br />
                                                {{ item.ProviderPostalCode }}
                                                {{ item.ProviderCity }} <br />
                                                <a
                                                    :href="
                                                        `https://${item.ProviderWebsite}`
                                                    "
                                                    target="_blank"
                                                >
                                                    {{ item.ProviderWebsite }}
                                                </a>
                                                {{ item.Comments }}
                                            </td>
                                            <td
                                                colspan="3"
                                                class="table-bottom text-right cell__mobile"
                                            ></td>
                                            <td colspan="3" class="text-left">
                                                <span v-if="item.StudentNumber">
                                                    Aantal leerlingen:
                                                    {{ item.StudentNumber }}
                                                    <br />
                                                </span>
                                                <span v-if="item.Price">
                                                    Prijs: €
                                                    {{ item.Price }}
                                                    <br />
                                                </span>
                                                <span v-if="item.NewPrice">
                                                    De nieuwe prijs na
                                                    kortingen: €
                                                    {{ item.NewPrice }}
                                                    <br />
                                                </span>
                                                <span v-if="item.DiscountType">
                                                    Er is gebruik gemaakt van de
                                                    volgende kortingen:
                                                    {{ item.DiscountType }}
                                                    <br />
                                                </span>
                                                <span v-if="item.Invoice">
                                                    Factuurnummer:
                                                    {{ item.Invoice }}
                                                    <br />
                                                </span>
                                                {{ item.Notice }}
                                                <a
                                                    v-if="
                                                        item.ProviderPhone !=
                                                            null
                                                    "
                                                    class="button button--default button--purple-2 col-6 button--small mt-2"
                                                    :href="
                                                        'tel:' +
                                                            item.ProviderPhone
                                                    "
                                                >
                                                    <span>
                                                        contact
                                                        <i
                                                            class="ml-1 color--white fas fa-phone"
                                                        ></i>
                                                    </span>
                                                </a>
                                            </td>
                                        </template>
                                    </v-data-table>
                                    <p
                                        v-if="!pastBookingItems"
                                        class="pt-2 pl-2"
                                    >
                                        Er zijn geen oude boekingen
                                    </p>
                                    <div class="text-center pt-2">
                                        <v-pagination
                                            v-model="page"
                                            :length="
                                                getPageCount(pastBookingItems)
                                            "
                                        ></v-pagination>
                                    </div>
                                </template>
                            </v-tab-item>
                            <v-tab
                                v-if="
                                    profile.ContentTypeAlias == 'school' &&
                                        teacherBookingItems.length > 0
                                "
                                href="#three"
                            >
                                Goed te keuren boekingen
                                <small
                                    >({{ teacherBookingItems.length }})
                                    <i class="fas fa-exclamation-triangle"></i>
                                </small>
                            </v-tab>
                            <v-tab-item id="three">
                                <template>
                                    <v-data-table
                                        :headers="bookingHeaders"
                                        :items="teacherBookingItems"
                                        show-expand
                                        single-expand
                                        item-key="Invoice"
                                        :search="searchTerm"
                                        :page.sync="page"
                                        :items-per-page="itemsPerPage"
                                        class="elevation-1 font-family--body"
                                        @page-count="pageCount = $event"
                                        @click:row="
                                            (item, slot) =>
                                                slot.expand(!slot.isExpanded)
                                        "
                                    >
                                        <template v-slot:top>
                                            <v-row align="center">
                                                <p
                                                    class="pt-2 mt-2 pb-0 ml-2 mb-0"
                                                >
                                                    Filter resultaten:
                                                </p>
                                            </v-row>
                                            <v-row align="center">
                                                <v-col
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-select
                                                        v-model="
                                                            groupsFilterValue
                                                        "
                                                        :items="
                                                            currentGroupsList
                                                        "
                                                        label="Groep"
                                                        single
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col
                                                    v-if="
                                                        profile.ContentTypeAlias !=
                                                            'parent'
                                                    "
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-select
                                                        v-model="
                                                            providerFilterValue
                                                        "
                                                        :items="
                                                            currentProviderList
                                                        "
                                                        label="Aanbieder"
                                                        single
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col
                                                    v-if="
                                                        profile.ContentTypeAlias ==
                                                            'parent'
                                                    "
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-select
                                                        v-model="
                                                            childFilterValue
                                                        "
                                                        :items="
                                                            currentChildList
                                                        "
                                                        label="Kind"
                                                        single
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col
                                                    class="d-flex"
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <v-card-title class="pt-0">
                                                        <v-text-field
                                                            v-model="searchTerm"
                                                            append-icon="fa-magnify"
                                                            label="Zoeken"
                                                            single-line
                                                            hide-details
                                                        ></v-text-field>
                                                    </v-card-title>
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <template
                                            v-slot:expanded-item="{ item }"
                                        >
                                            <td
                                                colspan="2"
                                                class="cell__mobile"
                                            ></td>
                                            <td>
                                                {{ item.ProviderStreet }}
                                                {{ item.ProviderHouseNumber }}
                                                {{
                                                    item.ProviderHouseNumberAddition
                                                }}
                                                <br />
                                                {{ item.ProviderPostalCode }}
                                                {{ item.ProviderCity }} <br />
                                                <a
                                                    :href="
                                                        `https://${item.ProviderWebsite}`
                                                    "
                                                    target="_blank"
                                                >
                                                    {{ item.ProviderWebsite }}
                                                </a>
                                                {{ item.Comments }}
                                            </td>
                                            <td
                                                colspan="3"
                                                class="table-bottom text-right cell__mobile"
                                            ></td>
                                            <td colspan="3" class="text-left">
                                                <span v-if="item.StudentNumber">
                                                    Aantal leerlingen:
                                                    {{ item.StudentNumber }}
                                                    <br />
                                                </span>
                                                <span v-if="item.Price">
                                                    Prijs: €
                                                    {{ item.Price }}
                                                    <br />
                                                </span>
                                                <span v-if="item.NewPrice">
                                                    De nieuwe prijs na
                                                    kortingen: €
                                                    {{ item.NewPrice }}
                                                    <br />
                                                </span>
                                                <span v-if="item.DiscountType">
                                                    Er is gebruik gemaakt van de
                                                    volgende kortingen:
                                                    {{ item.DiscountType }}
                                                    <br />
                                                </span>
                                                <span v-if="item.Invoice">
                                                    Factuurnummer:
                                                    {{ item.Invoice }}
                                                    <br />
                                                </span>
                                                {{ item.Notice }}
                                                <div
                                                    v-if="
                                                        item.ProviderPhone !=
                                                            null
                                                    "
                                                >
                                                    <a
                                                        class="button w-100 btn--dance button--small mt-2"
                                                        :href="
                                                            'tel:' +
                                                                item.ProviderPhone
                                                        "
                                                    >
                                                        <span>
                                                            <span
                                                                class="d-none d-md-inline-block"
                                                                >Bel</span
                                                            >
                                                            <i
                                                                class="ml-1 color--white fas fa-phone"
                                                            ></i>
                                                        </span>
                                                    </a>
                                                </div>
                                                <div
                                                    v-if="
                                                        item.ProviderEmail !=
                                                            null
                                                    "
                                                >
                                                    <a
                                                        class="button w-100 btn button--small mt-2"
                                                        :href="
                                                            'mailto:' +
                                                                item.ProviderEmail
                                                        "
                                                        target="_blank"
                                                    >
                                                        <span>
                                                            <span
                                                                class="d-none d-md-inline-block"
                                                                >E-mail</span
                                                            >
                                                            <i
                                                                class="ml-1 color--white fas fa-envelope"
                                                            ></i>
                                                        </span>
                                                    </a>
                                                </div>
                                                <hr />
                                                <v-dialog
                                                    v-model="dialog"
                                                    transition="dialog-bottom-transition"
                                                    max-width="600"
                                                >
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs
                                                        }"
                                                    >
                                                        <a
                                                            class="btn w-100 btn--medium btn--blue-7"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <span>
                                                                Status wijzigen
                                                            </span>
                                                        </a>
                                                    </template>
                                                    <v-card>
                                                        <v-card-title
                                                            class="headline"
                                                        >
                                                            Status wijzigen
                                                        </v-card-title>
                                                        <v-card-text>
                                                            Wil je de boeking
                                                            goedkeuren of
                                                            annuleren?
                                                        </v-card-text>
                                                        <textarea-input
                                                            v-model="
                                                                cancellationMessage
                                                            "
                                                            class="mb-2 px-3"
                                                            name="Opmerkingen"
                                                        />
                                                        <hr />
                                                        <v-card-actions
                                                            class="justify-content-center"
                                                        >
                                                            <button
                                                                class="btn btn--medium btn--blue-7 mt-2 mr-1"
                                                                @click="
                                                                    schoolApproveRegistration(
                                                                        item
                                                                    ),
                                                                        (dialog = false)
                                                                "
                                                            >
                                                                <span>
                                                                    Boeking
                                                                    goedkeuren
                                                                    <i
                                                                        class="ml-1 color--white fas fa-check"
                                                                    ></i>
                                                                </span>
                                                            </button>
                                                            <button
                                                                class="btn btn--medium btn--culture mt-2 ml-1"
                                                                @click="
                                                                    cancelRegistration(
                                                                        item
                                                                    ),
                                                                        (dialog = false)
                                                                "
                                                            >
                                                                <span>
                                                                    Boeking
                                                                    annuleren
                                                                    <i
                                                                        class="ml-1 color--white fas fa-times"
                                                                    ></i>
                                                                </span>
                                                            </button>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-dialog>
                                            </td>
                                        </template>
                                    </v-data-table>
                                    <p
                                        v-if="!teacherBookingItems"
                                        class="pt-2 pl-2"
                                    >
                                        Er zijn geen boekingen
                                    </p>
                                    <div class="text-center pt-2">
                                        <v-pagination
                                            v-model="page"
                                            :length="
                                                getPageCount(
                                                    teacherBookingItems
                                                )
                                            "
                                        ></v-pagination>
                                    </div>
                                </template>
                            </v-tab-item>
                        </v-tabs>
                        <clientdashboard-new-activities class="btn-visible" />
                    </div>
                </div>
                <dashboardMessage
                    :message="responseMessage"
                    :process="isProcessing"
                />
            </div>
        </section>
    </div>
</template>

<script>
import clientdashboardNewActivities from './clientdashboard-new-activities';
import dashboardMessage from '@/components/clientdashboard/dashboard-profile/clientdashboard-profile-message';
import Vuetify from 'vuetify';
import axios from 'axios';
import textareaInput from '@/components/form/textarea-input';

export default {
    components: {
        clientdashboardNewActivities,
        dashboardMessage,
        textareaInput
    },
    vuetify: new Vuetify(),
    props: {
        currentBookings: {
            type: Array,
            required: true
        },
        pastBookings: {
            type: Array,
            required: true
        },
        teacherBookings: {
            type: Array,
            required: true
        },
        user: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            searchTerm: '',
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            singleExpand: true,
            expanded: [],
            expandedTeacher: [],
            expandedHistory: [],
            pastProviderList: [],
            pastGroupsList: [],
            pastChildList: [],
            currentProviderList: [],
            currentGroupsList: [],
            currentChildList: [],
            providerFilterValue: '',
            groupsFilterValue: null,
            childFilterValue: '',
            pastBookingItems: [],
            currentBookingItems: [],
            teacherBookingItems: [],
            profile: {},
            dialog: false,
            cancellationMessage: '',
            optionEdit: 'Wijzigen',
            optionCancel: 'Cancel',
            cancelToggleButton: undefined,
            isProcessing: false,
            responseMessage: '',
            responseMessageTimeout: null
        };
    },
    computed: {
        bookingHeaders() {
            if (this.profile.ContentTypeAlias === 'parent') {
                return [
                    {
                        text: 'Kind',
                        value: 'Child',
                        filter: this.groupsFilter
                    },
                    { text: 'Activiteit', value: 'Activity' },
                    {
                        text: 'Aanbieder',
                        value: 'Provider',
                        filter: this.providerFilter
                    },
                    { text: 'Schooljaar', value: 'Year' },
                    { text: 'Inschrijfdatum', value: 'RegistrationDate' },
                    { text: 'Deelnamedatum', value: 'ParticipationDate' },
                    { text: 'Voorkeursmoment', value: 'Date' },
                    { text: 'Tijd', value: 'Time' },
                    { text: 'Status registratie', value: 'RegistrationStatus' },
                    { text: 'Status', value: 'Status' },
                    { text: '', value: 'data-table-expand' }
                ];
            } else {
                return [
                    {
                        text: 'Groep',
                        value: 'Class',
                        filter: this.groupsFilter
                    },
                    { text: 'Activiteit', value: 'Activity' },
                    {
                        text: 'Aanbieder',
                        value: 'Provider',
                        filter: this.providerFilter
                    },
                    { text: 'Schooljaar', value: 'Year' },
                    { text: 'Inschrijfdatum', value: 'RegistrationDate' },
                    { text: 'Deelnamedatum', value: 'ParticipationDate' },
                    { text: 'Tijd', value: 'Time' },
                    { text: 'Status registratie', value: 'RegistrationStatus' },
                    { text: 'Status', value: 'Status' },
                    { text: '', value: 'data-table-expand' }
                ];
            }
        }
    },
    mounted() {
        this.profile = JSON.parse(this.user);

        this.currentBookingItems = [];

        for (let i = 0; i <= this.currentBookings.length - 1; i++) {
            for (
                let j = 0;
                j <= this.currentBookings[i].Bookings.length - 1;
                j++
            ) {
                this.currentBookingItems.push(
                    this.currentBookings[i].Bookings[j]
                );
            }
        }

        if (this.currentBookingItems != null) {
            this.currentProviderList = [
                ...new Set(
                    this.currentBookingItems.map(
                        currentBookingItems => currentBookingItems.Provider
                    )
                )
            ];
            this.currentGroupsList = [
                ...new Set(
                    this.currentBookingItems.map(
                        currentBookingItems => currentBookingItems.Class
                    )
                )
            ];
            this.currentChildList = [
                ...new Set(
                    this.currentBookingItems.map(
                        currentBookingItems => currentBookingItems.Child
                    )
                )
            ];
        }

        this.pastBookingItems = [];

        for (let i = 0; i <= this.pastBookings.length - 1; i++) {
            for (
                let j = 0;
                j <= this.pastBookings[i].Bookings.length - 1;
                j++
            ) {
                this.pastBookingItems.push(this.pastBookings[i].Bookings[j]);
            }
        }

        if (this.pastBookingItems != null) {
            this.pastProviderList = [
                ...new Set(
                    this.pastBookingItems.map(
                        pastBookingItems => pastBookingItems.Provider
                    )
                )
            ];
            this.pastGroupsList = [
                ...new Set(
                    this.pastBookingItems.map(
                        pastBookingItems => pastBookingItems.Class
                    )
                )
            ];
            this.pastChildList = [
                ...new Set(
                    this.pastBookingItems.map(
                        pastBookingItems => pastBookingItems.Child
                    )
                )
            ];
        }

        this.teacherBookingItems = [];

        for (let i = 0; i <= this.teacherBookings.length - 1; i++) {
            for (
                let j = 0;
                j <= this.teacherBookings[i].Bookings.length - 1;
                j++
            ) {
                this.teacherBookingItems.push(
                    this.teacherBookings[i].Bookings[j]
                );
            }
        }

        if (this.teacherBookingItems != null) {
            this.pastProviderList = [
                ...new Set(
                    this.teacherBookingItems.map(
                        teacherBookingItems => teacherBookingItems.Provider
                    )
                )
            ];
            this.pastGroupsList = [
                ...new Set(
                    this.teacherBookingItems.map(
                        teacherBookingItems => teacherBookingItems.Class
                    )
                )
            ];
            this.pastChildList = [
                ...new Set(
                    this.teacherBookingItems.map(
                        teacherBookingItems => teacherBookingItems.Child
                    )
                )
            ];
        }
    },
    methods: {
        unexpand() {
            this.expanded = [];
        },
        getPageCount(value) {
            if (value == null) {
                return 0;
            }
            return Math.ceil(value.length / this.itemsPerPage);
        },
        providerFilter(value) {
            // If this filter has no value we just skip the entire filter.
            if (!this.providerFilterValue || !this.providerFilterValue.length) {
                return true;
            }

            // Check if the current loop value
            // equals to the selected value at the <v-select>.
            return value === this.providerFilterValue.toString();
        },
        groupsFilter(value) {
            if (!this.groupsFilterValue || !this.groupsFilterValue.length) {
                return true;
            }
            return value === this.groupsFilterValue.toString();
        },
        childFilter(value) {
            if (!this.childFilterValue || !this.childFilterValue.length) {
                return true;
            }
            return value === this.childFilterValue.toString();
        },
        archive(booking) {
            this.isProcessing = true;
            axios
                .post('/clientdashboard/bookings/archive', {
                    RegistrationId: booking.RegistrationId,
                    RegistrationEmail: booking.RegistrationEmail
                })
                .then(() => {
                    this.showMessage('Boeking gearchiveerd');
                    this.currentBookingItems.splice(
                        this.currentBookingItems.indexOf(booking),
                        1
                    );
                    this.pastBookingItems.push(booking);
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        },
        cancelRegistration(booking) {
            this.isProcessing = true;
            axios
                .post('/api/registrationstatusflow/registrationcancelled', {
                    RegistrationId: booking.RegistrationId,
                    RegistrantId: this.profile.Id,
                    ActivityId: booking.ActivityId,
                    ProviderId: booking.ProviderId,
                    ContactEmail: this.profile.Email,
                    ContactName: this.profile.ContactPersonFullName,
                    CurrentStatusId: booking.RegistrationStatusId,
                    ChangedBy: this.profile.MemberTypeAlias,
                    CancelledBy: this.profile.MemberTypeAlias,
                    CancellationMessage: this.cancellationMessage
                })
                .then(() => {
                    this.showMessage('Boeking geannuleerd');
                })
                .catch(() => {
                    this.showMessage(
                        'Helaas, er is iets misgegaan bij het verwerken'
                    );
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        },
        updateRegistration(booking) {
            this.isProcessing = true;
            axios
                .post('/api/registrationstatusflow/registrationfieldschanged', {
                    RegistrationId: booking.RegistrationId,
                    ActivityId: booking.ActivityId,
                    ProviderId: booking.ProviderId,
                    ContactEmail: this.profile.Email,
                    CurrentStatusId: booking.RegistrationStatusId,
                    ChangedBy: this.profile.MemberTypeAlias,
                    UpdateMessage: 'Registration Updated',
                    Registration: booking
                })
                .then(response => {
                    this.showMessage(response.data);
                })
                .catch(() => {
                    this.showMessage(
                        'Helaas, er is iets misgegaan bij het verwerken'
                    );
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        },
        schoolApproveRegistration(booking) {
            this.isProcessing = true;

            axios
                .post(
                    '/api/registrationstatusflow/registrationapprovedbyschool',
                    {
                        RegistrationId: booking.RegistrationId,
                        ActivityId: booking.ActivityId,
                        ProviderId: booking.ProviderId,
                        ContactEmail: this.profile.Email,
                        ContactName: this.profile.ContactPersonFullName,
                        CurrentStatusId: booking.RegistrationStatusId,
                        RegistrantId: this.profile.Id
                    }
                )
                .then(() => {
                    this.showMessage('Boeking goedgekeurd');
                    this.teacherBookingItems.splice(
                        this.teacherBookingItems.indexOf(booking),
                        1
                    );
                    this.refreshApprovedRegistration();
                })
                .catch(() => {
                    this.showMessage(
                        'Helaas, er is iets misgegaan bij het verwerken'
                    );
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        },
        refreshApprovedRegistration() {
            axios
                .get('/clientdashboard/bookings/approvedregistrations')
                .then(data => {
                    this.currentBookingItems = [];
                    for (let i = 0; i <= data.data.length - 1; i++) {
                        for (
                            let j = 0;
                            j <= data.data[i].Bookings.length - 1;
                            j++
                        ) {
                            this.currentBookingItems.push(
                                data.data[i].Bookings[j]
                            );
                        }
                    }

                    if (this.currentBookingItems != null) {
                        this.currentProviderList = [
                            ...new Set(
                                this.currentBookingItems.map(
                                    currentBookingItems =>
                                        currentBookingItems.Provider
                                )
                            )
                        ];
                        this.currentGroupsList = [
                            ...new Set(
                                this.currentBookingItems.map(
                                    currentBookingItems =>
                                        currentBookingItems.Class
                                )
                            )
                        ];
                        this.currentChildList = [
                            ...new Set(
                                this.currentBookingItems.map(
                                    currentBookingItems =>
                                        currentBookingItems.Child
                                )
                            )
                        ];
                    }
                })
                .catch(() => {
                    this.showMessage(
                        'Helaas, er is iets misgegaan bij het verwerken'
                    );
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        },
        showMessage(message) {
            this.responseMessage = message;

            if (this.responseMessageTimeout != null) {
                clearTimeout(this.responseMessageTimeout);
            }
            const self = this;
            this.responseMessageTimeout = setTimeout(() => {
                self.responseMessage = '';
            }, 3500);
        }
    }
};
</script>
<style lang="scss">
@import url('https://cdn.jsdelivr.net/npm/@mdi/font@5.8.55/css/materialdesignicons.min.css');

.v-data-table__empty-wrapper {
    display: none;
}
.v-tabs-bar__content small {
    font-size: 65%;
    margin-left: 5px;

    & i {
        color: rgb(255, 217, 0);
    }
}
.toggle-btn {
    box-shadow: none;
}
.v-data-table .v-data-table__wrapper > table > tbody > tr > td:last-child {
    padding: 0;
}
</style>
